import React, { ReactNode } from 'react';
import URLConfig from '@Config/urls/url.config';
import { Box, Heading, SimpleGrid, Text, useToast } from '@chakra-ui/react';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getCardOppositionHistoryDataTableColumns, TCardOppositionHistoryDataTableMeta } from './CardOppositionHistoryDataTableMeta';
import CustomDrawer from '@Modules/core/components/CustomDrawer';
import FilterFormUI from '@Shared/components/form/FilterFormUI';
import filterFormMeta from './CardOppositionHistoryFilterFormMeta';
import { useNavigate } from 'react-router-dom';

type ILabelValue = {
  label: string,
  value: string,
}

export type IRowMoreDetails = {
  clientName: ILabelValue;
  cardHolderName: ILabelValue;
  cardType: ILabelValue;
  agency: ILabelValue;
  statusReason: ILabelValue;
}

const CardOppositionHistoryHandler = () => {

    const [rowDetails, setRowDetails] =
    React.useState<TCardOppositionHistoryDataTableMeta>({
      primaryKey: '',
      status: 'string',
      oppositionDate: 'string',
      reason: 'string',
      previousStatus: 'string',
      cardholderName: 'string',
      expiration: 'string',
      user: 'string',
      schema: '',
    });

  const detailsDrawerRef = React.useRef<any>(null);

  const toast = useToast();

  const fakeData: TCardOppositionHistoryDataTableMeta[] = [
    {
      primaryKey: 1,
      status: 'status1',
      oppositionDate: 'oppositionDate1',
      reason: 'reason1',
      previousStatus: 'previousStatus1',
      cardholderName: 'cardholderName1',
      expiration: 'expiration1',
      user: 'user1',
    },
    {
      primaryKey: 2,
      status: 'status2',
      oppositionDate: 'oppositionDate2',
      reason: 'reason2',
      previousStatus: 'previousStatus2',
      cardholderName: 'cardholderName2',
      expiration: 'expiration2',
      user: 'user2',
    },

  ];

  //   Initialize react Query to GET Data
  const queryKey = ['ReasonCardReplacement'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve(fakeData), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isFilterSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Filtrage executé avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'execution du filtrage",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const displayDetails = (row: any) => {
    setRowDetails(row.original);

    detailsDrawerRef?.current?.onOpen();
  };

  const navigate = useNavigate();

  const handleDisplayDetails = (row: any) => {
    const URL =
    URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
    .OPPOSITION_DETAIL +
    row.original.primaryKey;
    navigate(URL);
  }

  const columns = getCardOppositionHistoryDataTableColumns({
    handleDisplayDetails,
    isLoading,
    displayDetails,
  });

  var dataKeys = Object.keys(rowDetails)

  const drawerContent = 
  <>
  <SimpleGrid columns={3} spacing={5}>
    {dataKeys.map((key, i) => <Box key={i}>
      <Heading size='xs' textTransform='uppercase'>
        {columns.find(elt => elt.id === key)?.header as ReactNode}
      </Heading>
      <Text pt='2' fontSize='sm'>
        {rowDetails[key]}
      </Text>
    </Box>)}
  </SimpleGrid>
  </>

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
        await mutateAsync();
    } catch (error) {
        console.log(error);
    }*/
  };

  return (
    <>
      <Box mt={6}>
        <FilterFormUI meta={filterFormMeta} onSubmit={onSubmit} isLoading={isLoading} isSubmitting={isFilterSubmitting} />
        <CustomReactTable data={data || [{}, {}, {}]} columns={columns} />
        <CustomDrawer title='Détails' ref={detailsDrawerRef}>
          {drawerContent}
        </CustomDrawer>
      </Box>
    </>
  );
};

export default CardOppositionHistoryHandler;
